import * as moment from 'moment';

export function dateOfBirth(date: string) {
    return date ? moment(date, "DD-MM-YYYY").format('L') : "";
}
